var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hideUnavailableFacets)?_c('div',{ref:"collapseContainer",staticClass:"collapse",class:{ expanded: _vm.susactive, 'collapse-active': _vm.collapsed },attrs:{"id":_vm.accordionName}},[_c('details',{staticClass:"accordion",attrs:{"open":""}},[_c('summary',[_vm._t("title")],2),_c('div',[_vm._t("content")],2)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }